import createIconComponent from './utils/createIconComponent';
import React from 'react';
const PauseSolid = createIconComponent({
  height: 24,
  width: 24,
  content: [
    <rect key='0' height='22.9' rx='1.9' width='7.6' x='14' y='.5'></rect>,
    <rect key='1' height='22.9' rx='1.9' width='7.6' x='2' y='.5'></rect>,
  ],
});
PauseSolid.displayName = 'PauseSolid';
export default PauseSolid;
